<template>
  <div>
    <!-- 顶部导航 -->
    <div class="header">
      <div class="logo">
        <span class="logo-text">甲子商城</span>
        <span class="logo-tag">银联权益专属</span>
      </div>
      <div class="help" id="helpBtn" @click="helpClick()">？</div>
    </div>

    <!-- 帮助浮层 -->
    <div class="help-modal" :style="helpModal" id="helpModal">
      <p>1. 点击"立即兑换"即可领取代金券</p>
      <p>2. 代金券将自动存入您的账户</p>
      <p>3. 授权手机号作为登录手机号</p>
      <p>3. 如有疑问请联系客服：400-998-9999</p>
    </div>

    <!-- 主内容容器 -->
    <div class="container">
      <!-- Banner区域 -->
      <div class="banner">
        <div class="title">银联专享 · 甲子商城福利</div>
        <div class="sub-title">满{{ v_limit }}元立减{{ v_price }}元</div>
        <div class="desc">银联权益平台专属兑换券</div>
      </div>

      <!-- 优惠券卡片 -->
      <div class="coupon-card">
        <div class="icon">{{ v_price }}</div>
        <div class="info">
          <div class="amount">¥{{ v_price }}</div>
          <div class="condition">满{{ v_limit }}元可用</div>
          <div class="validity">兑换后30天有效</div>
        </div>
        <div class="tag">{{v_type_text}}</div>
      </div>
      <div class="coupon-desc">仅银联权益用户可兑换</div>

      <!-- 操作步骤 -->
      <div class="steps">
        <div class="step-item">
          <div class="step-icon">✓</div>
          <div class="step-text">确认兑换</div>
        </div>
        <div class="step-item">
          <div class="step-icon">→</div>
          <div class="step-text">领取券码</div>
        </div>
        <div class="step-item">
          <div class="step-icon">🛒</div>
          <div class="step-text">商城使用</div>
        </div>
      </div>

      <!-- 兑换按钮 -->
      <button
        class="exchange-btn"
        id="exchangeBtn"
        :disabled="exchangeBtn"
        @click="geBtndh()"
      >
        <span id="btnText" v-text="btnText"></span>
      </button>

      <!-- 规则说明 -->
      <div class="rules-section">
        <div class="rules-header" id="rulesHeader">
          <div class="rules-title">兑换规则</div>
          <div class="rules-arrow" id="rulesArrow">▼</div>
        </div>
        <div class="rules-content" id="rulesContent">
          <p>1. 本券为银联权益平台专属，仅限甲子商城全场商品使用；</p>
          <p>2. 单笔订单满{{ v_limit }}元可使用1张，不可叠加，不找零；</p>
          <p>3. 兑换成功自动绑定到权益平台下单手机号</p>
          <p>
            4. 使用<font style="font-weight: bold; color: red"
              >权益平台下单手机号</font
            >短信登录可查看/使用
          </p>
          <p>5. 退款订单券码不予返还，如有问题请联系客服：400-998-9999。</p>
        </div>
      </div>
    </div>

    <!-- 兑换成功弹窗 -->
    <div class="success-modal" id="successModal" :style="sucModal">
      <div class="success-icon">✓</div>
      <div class="success-text">兑换成功</div>
      <div class="success-desc">券码已存入您的账户，快去使用吧！</div>
      <div class="success-btns">
        <button class="success-btn confirm" id="closeBtn" @click="gohome()">去使用</button>
        <button class="success-btn" id="backBtn" @click="goback()">返回平台</button>
      </div>
    </div>
  </div>
</template>
<script>
import { Toast, Indicator } from "mint-ui";
import { qyh5api, qytestdhdd,qytestdh,qytestdhyy} from "../api/uniqyh5";
export default {
  name: "uniqyh5",
  data() {
    return {
      helpModal: "display:none", //控制帮助模块是否显示style变量
      sucModal:"display:none",//控制兑换成功,模块变量
      token: this.$route.query.token ? this.$route.query.token : 0, //从路由中获取变量token传入值
      qbackUrl: "", //权益平台跳转返回变量
      v_price: "--", //面额
      v_limit: "--", //门槛
      v_temp_id:0,//代金券模id
      btnText: "数据载入中...",
      exchangeBtn: true, //控制兑换按钮是否可以点击
      v_type_text:'全场通用',//代金券类型描述
      v_gobuy_url:'/home/index',//代金券去使用跳转相对路径地址
    };
  },
  methods: {
    gohome(){
      window.location.href=this.v_gobuy_url;
    },
    goback(){
      window.location.href = this.qbackUrl;
    },
    helpClick() {
      //反向赋值变量方法
      if (this.helpModal == "display:none") {
        this.helpModal = "display:block";
      } else {
        this.helpModal = "display:none";
      }
    },
    initdata() {
      //请求接口获取数据
      Indicator.open();
      qyh5api(this.token).then(
        (response) => {
          Indicator.close();
          console.log(response);
          var money = response.result.vinfo.vouchertemplate_price;
          var limitm = response.result.vinfo.vouchertemplate_limit;
          var tpid=response.result.vinfo.vouchertemplate_id;
          limitm = limitm.split(".")[0];
          this.v_limit = limitm;
          this.v_price = money;
          this.qbackUrl = response.result.qbackUrl;
          this.v_temp_id=tpid;
          this.v_gobuy_url=response.result.vinfo.v_gobuy_url;
          this.v_type_text=response.result.vinfo.v_type_text;
          //调用通知
          this.qytzapi();
        },
        (error) => {
          Indicator.close();
          //console.log(error);
          Toast(error.message);
        }
      );
    },
    async qytzapi() {
      //异步方法,处理通知-兑换中
      let res = await qytestdhdd(this.token);
      if (res.data.respCd == "100000") {
        this.btnText = "立即兑换";
        this.exchangeBtn = false;
      } else if (res.data.respCd == "100002") {
        Toast("加载数据失败,即将返回权益平台");
        setTimeout(() => {
          window.location.href = this.qbackUrl;
        }, 1000);
      } else {
        Toast(res.data.respMsg);
      }
    },
    geBtndlode(){//兑换按钮状态控制
      this.exchangeBtn =false;
      this.btnText = "立即兑换";
    },
    async geBtndh() {//异步方法,立即兑换
      Indicator.open();
      this.exchangeBtn =true;
      this.btnText = "兑换中...";
      let res = await qytestdh(this.token,this.v_temp_id);
      if (res.data.respCd == "100000") {
         Indicator.close();
         //通知权益平台-兑换成功
         let res2 = await qytestdhyy(this.token,res.data.vid);
         if(res2.data.respCd == "100002"){
             Toast("兑换失败");
             this.geBtndlode();
             return;
         }
         else if(res2.data.respCd == "100000"){
             this.geBtndlode();
             this.sucModal="display:block";
         }
         else{
            console.log("兑换成功--通知--其他错误");
         }

      } else if (res.data.respCd == "100002") {
        Indicator.close();
        this.geBtndlode();
        Toast("token过期,即将返回权益平台");
        setTimeout(() => {
          window.location.href = this.qbackUrl;
        }, 1000);
      } else {
        Indicator.close();
        this.geBtndlode();
        Toast(res.data.respMsg);
      }
    },
  },
  created() {
    //Vue生命周期函数 beforeCreate → created → beforeMount → mounted →
    //console.log("页面-初始化--执行");
    //console.log("页面-初始化--执行--之后token:-->" + this.token);
    this.initdata();
  },
  watch: {},
};
</script>
<style scoped lang='scss'>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
}

body {
  background-color: #ffffff;
  color: #333333;
  min-height: 100vh;
  padding-bottom: 20px;
}

/* 顶部导航栏 */
.header {
  height: 50px;
  background-color: #e85a4f;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 15px;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
}

.header .logo {
  display: flex;
  align-items: center;
}

.header .logo-text {
  color: #ffffff;
  font-size: 18px;
  font-weight: bold;
}

.header .logo-tag {
  color: #f8e9a1;
  font-size: 12px;
  margin-left: 8px;
}

.header .help {
  color: #ffffff;
  font-size: 20px;
  cursor: pointer;
}

/* 帮助浮层 */
.help-modal {
  position: fixed;
  top: 60px;
  right: 15px;
  background-color: #f8e9a1;
  border-radius: 8px;
  padding: 15px;
  width: 200px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  display: none;
  z-index: 101;
}

.help-modal.show {
  display: block;
}

.help-modal p {
  font-size: 12px;
  color: #333333;
  line-height: 1.5;
}

/* 主内容区 */
.container {
  padding: 60px 15px 0;
  max-width: 480px;
  margin: 0 auto;
}

/* Banner区域 */
.banner {
  height: 220px;
  background: linear-gradient(135deg, #e85a4f 0%, #f2994a 100%);
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  padding: 0 20px;
  position: relative;
  margin-bottom: 20px;
}

.banner::after {
  content: "";
  position: absolute;
  bottom: 10px;
  right: 20px;
  width: 60px;
  height: 60px;
  background: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMzAiIGN5PSIzMCIgcj0iMjUiIGZpbGw9IiNGRjhFOUExIi8+CjxwYXRoIGQ9Ik0zMCAxMFYzMCIgc3Ryb2tlPSIjRkY4RTlBMCIgc3Ryb2tlLXdpZHRoPSIyIi8+CjxwYXRoIGQ9Ik0xNSAzMFYxNSIgc3Ryb2tlPSIjRkY4RTlBMCIgc3Ryb2tlLXdpZHRoPSIyIi8+CjxwYXRoIGQ9Ik00NSAzMFYxNSIgc3Ryb2tlPSIjRkY4RTlBMCIgc3Ryb2tlLXdpZHRoPSIyIi8+CjxwYXRoIGQ9Ik0zMCA0NVYzMCIgc3Ryb2tlPSIjRkY4RTlBMCIgc3Ryb2tlLXdpZHRoPSIyIi8+CjxwYXRoIGQ9Ik0xNSA0NVYzMCIgc3Ryb2tlPSIjRkY4RTlBMCIgc3Ryb2tlLXdpZHRoPSIyIi8+CjxwYXRoIGQ9Ik00NSA0NVYzMCIgc3Ryb2tlPSIjRkY4RTlBMCIgc3Ryb2tlLXdpZHRoPSIyIi8+Cjwvc3ZnPg==")
    no-repeat;
  background-size: contain;
  opacity: 0.8;
}

.banner .title {
  font-size: 32px;
  font-weight: bold;
  margin-bottom: 8px;
  text-align: center;
}

.banner .sub-title {
  font-size: 24px;
  color: #f8e9a1;
  margin-bottom: 10px;
  text-align: center;
}

.banner .desc {
  font-size: 14px;
  text-align: center;
}

/* 优惠券卡片 */
.coupon-card {
  height: 150px;
  background-color: #ffffff;
  border: 2px solid #f8e9a1;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(232, 90, 79, 0.1);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  margin-bottom: 25px;
}

.coupon-card .icon {
  font-size: 40px;
  font-weight: bold;
  color: #e85a4f;
  background: linear-gradient(135deg, #e85a4f 0%, #f2994a 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.coupon-card .info {
  text-align: center;
  flex: 1;
  margin: 0 15px;
}

.coupon-card .amount {
  font-size: 28px;
  color: #e85a4f;
  font-weight: bold;
  margin-bottom: 5px;
}

.coupon-card .condition {
  font-size: 16px;
  color: #333333;
  margin-bottom: 5px;
}

.coupon-card .validity {
  font-size: 12px;
  color: #999999;
}

.coupon-card .tag {
  background-color: #f8e9a1;
  color: #333333;
  font-size: 14px;
  padding: 5px 10px;
  border-radius: 20px;
}

.coupon-desc {
  font-size: 12px;
  color: #999999;
  text-align: center;
  margin-top: -15px;
  margin-bottom: 20px;
}

/* 操作步骤 */
.steps {
  display: flex;
  justify-content: space-around;
  margin-bottom: 20px;
}

.steps .step-item {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.steps .step-icon {
  font-size: 20px;
  color: #e85a4f;
  margin-bottom: 5px;
}

.steps .step-text {
  font-size: 14px;
  color: #333333;
}

/* 兑换按钮 */
.exchange-btn {
  width: 100%;
  height: 50px;
  background: linear-gradient(135deg, #e85a4f 0%, #f2994a 100%);
  border: none;
  border-radius: 8px;
  color: #ffffff;
  font-size: 20px;
  font-weight: bold;
  cursor: pointer;
  margin-bottom: 25px;
  transition: background 0.2s ease;
}

.exchange-btn:hover {
  background: linear-gradient(135deg, #d64f44 0%, #e58a3f 100%);
}

.exchange-btn:disabled {
  background: #999999;
  cursor: not-allowed;
}

/* 规则说明区 */
.rules-section {
  background-color: #f5f5f5;
  border-radius: 10px;
  padding: 15px;
}

.rules-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  margin-bottom: 10px;
}

.rules-title {
  font-size: 14px;
  color: #333333;
  font-weight: 500;
}

.rules-arrow {
  color: #e85a4f;
  font-size: 16px;
  transition: transform 0.2s ease;
  transform: rotate(180deg); /* 默认旋转（展开状态） */
}

.rules-arrow.rotate {
  transform: rotate(0deg); /* 折叠状态 */
}

.rules-content {
  font-size: 12px;
  color: #999999;
  line-height: 1.5;
  display: block; /* 默认展开 */
}

.rules-content.hide {
  display: none; /* 折叠状态 */
}

.rules-content p {
  margin-bottom: 5px;
}

/* 兑换成功弹窗 */
.success-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, #e85a4f 0%, #f2994a 100%);
  display: none;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 200;
  color: #ffffff;
  padding: 0 20px;
  padding-top: 40%;
}

.success-modal.show {
  display: flex;
}

.success-icon {
  font-size: 60px;
  margin-bottom: 20px;
  text-align: center;
}

.success-text {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 10px;
  text-align: center;
}

.success-desc {
  font-size: 14px;
  margin-bottom: 40px;
  text-align: center;
}

/* 弹窗按钮组 */
.success-btns {
  display: flex;
  gap: 15px;
  width: 100%;
}

.success-btn {
  flex: 1;
  height: 45px;
  border: 2px solid #ffffff;
  border-radius: 8px;
  background: transparent;
  color: #ffffff;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s ease;
}

.success-btn.confirm {
  background: #ffffff;
  color: #e85a4f;
}

.success-btn:hover {
  background: rgba(255, 255, 255, 0.1);
}

.success-btn.confirm:hover {
  background: rgba(255, 255, 255, 0.9);
}

/* 加载动画 */
.loader {
  border: 3px solid #ffffff;
  border-top: 3px solid transparent;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  animation: spin 1s linear infinite;
  display: none;
}

.loader.show {
  display: inline-block;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* 响应式适配 */
@media (max-width: 375px) {
  .banner .title {
    font-size: 28px;
  }
  .banner .sub-title {
    font-size: 20px;
  }
  .coupon-card .amount {
    font-size: 24px;
  }
  .exchange-btn {
    font-size: 18px;
  }
  .success-btn {
    font-size: 14px;
  }
}

@media (max-width: 320px) {
  .banner .title {
    font-size: 24px;
  }
  .banner .sub-title {
    font-size: 18px;
  }
  .steps .step-text {
    font-size: 12px;
  }
}
/* 根节点适配 */
html {
  font-size: calc(100vw / 375 * 16);
  -webkit-text-size-adjust: 100%; /* 禁止iOS文字自动缩放 */
}
@media (min-width: 480px) {
  html {
    font-size: 16px;
  }
}

/* 全局基础 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
  word-wrap: break-word;
  word-break: break-all;
}

body {
  background-color: #ffffff;
  color: #333333;
  min-height: 100vh;
  padding-bottom: 20px;
}

/* 视口适配容器 */
.container {
  padding: 3.75rem 0.9375rem 0; /* 60px 15px 0 → rem单位 */
  max-width: 30rem; /* 480px */
  margin: 0 auto;
}

/* 核心按钮适配 */
.exchange-btn {
  width: 100%;
  height: 3.125rem; /* 50px */
  min-height: 2.75rem; /* 44px */
  background: linear-gradient(135deg, #e85a4f 0%, #f2994a 100%);
  border: none;
  border-radius: 0.5rem; /* 8px */
  color: #ffffff;
  font-size: 1.25rem; /* 20px */
  font-weight: bold;
  cursor: pointer;
  margin-bottom: 1.5625rem; /* 25px */
  transition: background 0.2s ease;
}

/* 媒体查询精细化适配 */
@media (max-width: 20rem) {
  /* 320px */
  .banner {
    height: 11.25rem; /* 180px */
  }
  .banner .title {
    font-size: 1.5rem; /* 24px */
  }
  .success-btns {
    gap: 0.625rem; /* 10px */
  }
}

@media (min-width: 20rem) and (max-width: 23.4375rem) {
  /* 320-375px */
  .coupon-card {
    padding: 0 0.9375rem; /* 15px */
  }
}

/* 横屏禁用 */
@media (orientation: landscape) {
  body::before {
    content: "请旋转手机至竖屏查看";
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: #e85a4f;
    color: #ffffff;
    font-size: 1.25rem;
    z-index: 9999;
  }
  .header,
  .container,
  .success-modal {
    display: none;

  }
}
</style>